module.exports = "../dist/frontend/icons/ui/googlePlay.svg?d8d21adec2c03326ce3bda0b910acd7d";